import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

import { BiRightArrowAlt } from 'react-icons/bi'

// Mock Data
import { transactionTrackerData } from '../../pages/mockData'
import { getTopTransactions } from '../../redux/actions/transactionAction'
import PlayerDetailsModal from '../modal/PlayerDetailsModal'
import { useDispatch, useSelector } from 'react-redux'
import { openModal } from '../../redux/actions/interfaceModalActions'

const TransactionTracker = ({ height }) => {
  const [topTransaction, setTopTransaction] = useState([])
  const userDetails = useSelector((state) => state.user.userDetails)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const getData = async () => {
    const data = await getTopTransactions()
    setTopTransaction(data)
  }

  useEffect(() => {
    getData()
  }, [])

  const SM = {
    movedToNonActive: 'moved to non-active',
    movedToActiveRoster: 'player has been moved to active roster',
    movedAuctionWaiver: 'player moved to auction, due to waiver exempt',
    movedProtectedList: 'moved to protected list',
    movedFromProtectedList: 'moved from protected list',
    playerTraded: 'player traded',
    released: 'released',
    movedIr: 'moved to injured reserve',
    movedLTIR: 'moved to lt injured reserve',
    auction: 'auction',
    approvedDraft: 'player approved from draft',
  }

  return (
    <div className='transaction_tracker_box'>
      <header>
        <h3>League Transaction Tracker</h3>
        <p onClick={() => navigate('/all-transaction')}>
          View All <BiRightArrowAlt size={18} />
        </p>
      </header>
      <section className='transaction_tracker_body' style={{ maxHeight: height }}>
        {topTransaction?.map((item, i) => {
          const module = item?.module?.toLowerCase()
          const subModule = item?.sub_module?.toLowerCase()
          return (
            <div key={i} className='card_box'>
              <div>
                <span className='text1'>Franchise:</span> &nbsp;
                <span className='text2'>{item?.team?.name}</span>
              </div>
              <div>
                <span className='text1'>Type:</span> &nbsp;
                <span className='text2'>{item?.module}</span>
              </div>
              <div>
                <span className='text1'>Date:</span> &nbsp;
                <span className='text2'>
                  {moment(item?.createdAt).format('ddd MMM D h:mm:ss a. [ET] YYYY')}
                </span>
              </div>
              <div>
                <span className='text1'>Transaction::</span> &nbsp;
                {module === 'squad' && subModule === SM.movedToNonActive && (
                  <span className='text2'>
                    Players move to non-active squad :{' '}
                    {item?.player?.map((v, index) => (
                      <>
                        <span
                          key={index}
                          style={{ color: 'var(--primary)' }}
                          onClick={() => {
                            dispatch(
                              openModal({
                                playerID: v?.PlayerID,
                                isReserve: v?.isReserve ? true : false,
                                teamId: null,
                                teamName: '',
                                teamLogo: null,
                                isTransaction: {
                                  status: true,
                                },
                              }),
                            )
                          }}
                        >
                          {v?.player_id?.Name}
                        </span>{' '}
                        ,
                      </>
                    ))}
                  </span>
                )}
                {module === 'squad' && subModule === SM.movedToActiveRoster && (
                  <span className='text2'>
                    {item?.sub_module}:{' '}
                    {item?.player?.map((v, index) => (
                      <>
                        <span
                          key={index}
                          style={{ color: 'var(--primary)' }}
                          onClick={() => {
                            dispatch(
                              openModal({
                                playerID: v?.PlayerID,
                                isReserve: v?.isReserve ? true : false,
                                teamId: null,
                                teamName: '',
                                teamLogo: null,
                                isTransaction: {
                                  status: true,
                                },
                              }),
                            )
                          }}
                        >
                          {v?.player_id?.Name}
                        </span>{' '}
                        ,
                      </>
                    ))}
                  </span>
                )}
                {module === 'waiver' && subModule === SM.movedAuctionWaiver && (
                  <span className='text2'>
                    {item?.sub_module}:{' '}
                    {item?.player?.map((v, index) => (
                      <>
                        <span
                          key={index}
                          style={{ color: 'var(--primary)' }}
                          onClick={() => {
                            dispatch(
                              openModal({
                                playerID: v?.PlayerID,
                                isReserve: v?.isReserve ? true : false,
                                teamId: null,
                                teamName: '',
                                teamLogo: null,
                                isTransaction: {
                                  status: true,
                                },
                              }),
                            )
                          }}
                        >
                          {v?.player_id?.Name}
                        </span>{' '}
                        ,
                      </>
                    ))}
                  </span>
                )}
                {module === 'squad' &&
                  (subModule === SM.movedProtectedList ||
                    subModule === SM.movedFromProtectedList) && (
                    <span className='text2'>
                      {item?.player?.map((v, index) => {
                        if (v?.status === 'from') {
                          return (
                            <>
                              <span
                                key={index}
                                style={{ color: 'var(--primary)' }}
                                onClick={() => {
                                  dispatch(
                                    openModal({
                                      playerID: v?.PlayerID,
                                      isReserve: v?.isReserve ? true : false,
                                      teamId: null,
                                      teamName: '',
                                      teamLogo: null,
                                      isTransaction: {
                                        status: true,
                                      },
                                    }),
                                  )
                                }}
                              >
                                {v?.player_id?.Name}
                              </span>{' '}
                              ,
                            </>
                          )
                        }
                      })}
                      {` Moved to Active Squad `}
                      {item?.player?.map((v, index) => {
                        if (v?.status === 'to') {
                          return (
                            <>
                              and{' '}
                              <>
                                <span
                                  key={index}
                                  style={{ color: 'var(--primary)' }}
                                  onClick={() => {
                                    dispatch(
                                      openModal({
                                        playerID: v?.PlayerID,
                                        isReserve: v?.isReserve ? true : false,
                                        teamId: null,
                                        teamName: '',
                                        teamLogo: null,
                                        isTransaction: {
                                          status: true,
                                        },
                                      }),
                                    )
                                  }}
                                >
                                  {v?.player_id?.Name}
                                </span>{' '}
                                ,
                              </>
                              Moved to Protected List
                            </>
                          )
                        }
                      })}
                    </span>
                  )}
                {module === 'trade' && subModule === SM.playerTraded && (
                  <span className='text2'>
                    {item?.player?.map((v, index) => {
                      if (v?.status === 'buyer') {
                        return (
                          <>
                            <span
                              key={index}
                              style={{ color: 'var(--primary)' }}
                              onClick={() => {
                                dispatch(
                                  openModal({
                                    playerID: v?.PlayerID,
                                    isReserve: v?.isReserve ? true : false,
                                    teamId: null,
                                    teamName: '',
                                    teamLogo: null,
                                    isTransaction: {
                                      status: true,
                                    },
                                  }),
                                )
                              }}
                            >
                              {v?.player_id?.Name}
                            </span>{' '}
                            ,
                          </>
                        )
                      }
                    })}
                    {` has been traded with `}
                    {item?.player?.map((v, index) => {
                      if (v?.status === 'seller') {
                        return (
                          <>
                            <>
                              <span
                                key={index}
                                style={{ color: 'var(--primary)' }}
                                onClick={() => {
                                  dispatch(
                                    openModal({
                                      playerID: v?.PlayerID,
                                      isReserve: v?.isReserve ? true : false,
                                      teamId: null,
                                      teamName: '',
                                      teamLogo: null,
                                      isTransaction: {
                                        status: true,
                                      },
                                    }),
                                  )
                                }}
                              >
                                {v?.player_id?.Name}
                              </span>
                            </>
                          </>
                        )
                      }
                    })}
                    {` from ${item?.sellerTradeTeam?.name}`}
                  </span>
                )}
                {module === 'squad' && subModule === SM.released && (
                  <span className='text2'>
                    Release from squad:{' '}
                    <span style={{ color: 'var(--primary)' }}>
                      {item?.player?.map((v, index) => (
                        <span
                          key={index}
                          style={{ color: 'var(--primary)' }}
                          onClick={() => {
                            dispatch(
                              openModal({
                                playerID: v?.PlayerID,
                                isReserve: v?.isReserve ? true : false,
                                teamId: null,
                                teamName: '',
                                teamLogo: null,
                                isTransaction: {
                                  status: true,
                                },
                              }),
                            )
                          }}
                        >
                          {v?.player_id?.Name}
                        </span>
                      ))}
                    </span>{' '}
                  </span>
                )}
                {module === 'squad' && (subModule === SM.movedIr || subModule === SM.movedLTIR) && (
                  <span className='text2'>
                    <span style={{ color: 'var(--primary)' }}>
                      {item?.player?.map((v, index) => (
                        <span
                          key={index}
                          style={{ color: 'var(--primary)' }}
                          onClick={() => {
                            dispatch(
                              openModal({
                                playerID: v?.PlayerID,
                                isReserve: v?.isReserve ? true : false,
                                teamId: null,
                                teamName: '',
                                teamLogo: null,
                                isTransaction: {
                                  status: true,
                                },
                              }),
                            )
                          }}
                        >
                          {v?.player_id?.Name}
                        </span>
                      ))}
                    </span>{' '}
                    {item?.sub_module}
                  </span>
                )}
                {module === 'squad' && subModule === SM.auction && (
                  <span className='text2'>
                    <span style={{ color: 'var(--primary)' }}>
                      {item?.player?.map((v, index) => (
                        <>
                          <span
                            key={index}
                            style={{ color: 'var(--primary)' }}
                            onClick={() => {
                              dispatch(
                                openModal({
                                  playerID: v?.PlayerID,
                                  isReserve: v?.isReserve ? true : false,
                                  teamId: null,
                                  teamName: '',
                                  teamLogo: null,
                                  isTransaction: {
                                    status: true,
                                  },
                                }),
                              )
                            }}
                          >
                            {v?.player_id?.Name}
                          </span>{' '}
                          ,
                        </>
                      ))}
                    </span>{' '}
                    moved to auction
                  </span>
                )}
                {module === 'squad' && subModule === SM.approvedDraft && (
                  <span className='text2'>
                    Approved from draft:{' '}
                    {item?.player?.map((v, index) => (
                      <span
                        key={index}
                        style={{ color: 'var(--primary)' }}
                        onClick={() => {
                          dispatch(
                            openModal({
                              playerID: v?.PlayerID,
                              isReserve: v?.isReserve ? true : false,
                              teamId: null,
                              teamName: '',
                              teamLogo: null,
                              isTransaction: {
                                status: true,
                              },
                            }),
                          )
                        }}
                      >
                        {v?.player_id?.Name}
                      </span>
                    ))}
                  </span>
                )}
              </div>
            </div>
          )
        })}
        <PlayerDetailsModal />
      </section>
    </div>
  )
}

export default TransactionTracker
